import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { notifyError, notifyMessage } from '@/services/notify'
import { KMS_BACKEND } from '@/config'

export const methods = {
  async saveMessageForFinalize(content, subject, isDuplexParam, isColorParam) {
    console.debug(
      'finalizeMessage postal...' +
        content +
        ', ' +
        subject +
        ', ' +
        isDuplexParam +
        ', ' +
        isColorParam
    )

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    if (content === undefined || !content || content.length === 0) {
      notifyError('The message is required.')
      return
    }

    this.$store.dispatch('communication/saveCompositionMethod', {
      compositionMethod: 'html'
    })

    this.$store
      .dispatch('communication/selectedUploadFile', {
        uploadFile: null
      })
      .then(() => {
        this.$store
          .dispatch('communication/savePdfFileName', {
            pdfFileName: ''
          })
          .then(() => {
            this.$store
              .dispatch('communication/saveIsFullDuplex', {
                isFullDuplex: isDuplexParam
              })
              .then(() => {
                this.$store
                  .dispatch('communication/saveIsColor', {
                    isColor: isColorParam
                  })
                  .then(() => {
                    this.$store
                      .dispatch('communication/composedMailMessage', {
                        mailMessage: content
                      })
                      .then(() => {
                        this.composedText = content
                        this.$store.dispatch('communication/saveCompositionMethod', {
                          compositionMethod: 'html'
                        })
                      })
                  })
              })
          })
      })

    loadingComponent.close()
  },

  uploadOrEnterChanged() {
    console.debug('in uploadOrEnterChanged()...')
    if (this.formData.uploadOrEnter === 'Enter') {
      console.debug('in Enter...')
      this.$store
        .dispatch('communication/saveCompositionMethod', {
          compositionMethod: 'html'
        })
        .then(() => {
          this.$store
            .dispatch('communication/savePdfFileName', {
              pdfFileName: ''
            })
            .then(() => {
              this.$store.dispatch('communication/selectedUploadFile', {
                uploadFile: null
              })
            })
        })

      this.base64pdf = ''
      this.file = null
    } else if (this.formData.uploadOrEnter === 'Upload') {
      console.debug('in Upload...')
      this.$store
        .dispatch('communication/saveCompositionMethod', {
          compositionMethod: 'pdf-document'
        })
        .then(() => {
          this.$store.dispatch('communication/composedMailMessage', {
            mailMessage: ''
          })
        })
    } else {
      this.$store.dispatch('communication/saveCompositionMethod', {
        compositionMethod: ''
      })

      this.formData.uploadOrEnter = ''
    }
  },

  async finalizeMessageFromState(showMessage) {
    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    if (!this.mailMessage) {
      notifyError('Please Enter a mail message.')
      return
    }

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    this.$store
      .dispatch('communication/selectedUploadFile', {
        uploadFile: null
      })
      .then(() => {
        this.$store
          .dispatch('communication/savePdfFileName', {
            pdfFileName: ''
          })
          .then(() => {
            this.$store.dispatch('communication/saveCompositionMethod', {
              compositionMethod: 'html'
            })
          })
      })

    try {
      this.composedText = this.mailMessage

      if (this.composedText && this.composedText.length > 0) {
        const params = {
          communicationID:
            this.mailingCommunicationID > 0 ? this.mailingCommunicationID : this.communicationID,
          supportMailDelivery: true,
          supportEmailDelivery: false,
          supportSMSDelivery: false,
          isLegalCommunication: this.isLegalCommunication,
          htmlContent: this.composedText,
          mailFullDuplex: this.isFullDuplex,
          mailColor: this.isColor,
          documentID: null,
          compositionMethod: 'html',
          description: this.communicationDescription,
          mailingTypeID: this.mailingTypeID,
          selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
          selectedDeliveryOwners: this.selectedDeliveryOwners,
          deliveryDate: this.deliveryDate,
          isFullDuplex: this.isFullDuplex,
          isColor: this.isColor
        }

        console.debug('mail params=' + JSON.stringify(params))

        await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
          params,
          done: async ({ detail }) => {
            this.$store.dispatch('communication/saveIsEdit', {
              isEdit: true
            })

            if (detail) {
              console.debug('update communication=' + JSON.stringify(detail))

              this.communicationID = detail.communicationID

              this.$store.dispatch('communication/saveCompositionMethod', {
                compositionMethod: 'html'
              })

              if (showMessage !== undefined && showMessage && showMessage === true) {
                notifyMessage('This message has been saved for sending.')
              }
              loadingComponent.close()
            }
            loadingComponent.close()
          }
        })
      }
    } catch (error) {
      console.debug('error=' + error.message)
      loadingComponent.close()
    }

    loadingComponent.close()
  },

  async finalizeMessage(content, subject, isDuplexParam, isColorParam) {
    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    if (this.hasReadonly === false) {
      console.debug(
        'finalizeMessage postal...' +
          content +
          ', ' +
          subject +
          ', ' +
          isDuplexParam +
          ', ' +
          isColorParam
      )

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (content === undefined || !content || content.length === 0) {
        notifyError('The message is required.')
        return
      }

      this.$store
        .dispatch('communication/selectedUploadFile', {
          uploadFile: null
        })
        .then(() => {
          this.$store
            .dispatch('communication/savePdfFileName', {
              pdfFileName: ''
            })
            .then(() => {
              this.$store
                .dispatch('communication/saveIsFullDuplex', {
                  isFullDuplex: isDuplexParam
                })
                .then(() => {
                  this.$store
                    .dispatch('communication/saveIsColor', {
                      isColor: isColorParam
                    })
                    .then(() => {
                      this.$store.dispatch('communication/saveCompositionMethod', {
                        compositionMethod: 'html'
                      })
                    })
                })
            })
        })

      console.debug('isFullDuplex=' + this.isFullDuplex)
      console.debug('isColor=' + this.isColor)

      try {
        if (content && content.length > 0) {
          this.$store.dispatch('communication/composedMailMessage', {
            mailMessage: content
          })
          this.composedText = content

          console.debug(
            'communicationID=' +
              this.communicationID +
              ', ' +
              this.mailingCommunicationID +
              ', ' +
              this.communication.communicationID
          )

          const params = {
            communicationID:
              this.mailingCommunicationID > 0 ? this.mailingCommunicationID : this.communicationID,
            supportMailDelivery: true,
            supportEmailDelivery: false,
            supportSMSDelivery: false,
            isLegalCommunication: this.isLegalCommunication,
            htmlContent: content,
            mailFullDuplex: isDuplexParam,
            mailColor: isColorParam,
            documentID: null,
            compositionMethod: 'html',
            description: this.communicationDescription,
            mailingTypeID: this.mailingTypeID,
            selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
            selectedDeliveryOwners: this.selectedDeliveryOwners,
            deliveryDate: this.deliveryDate,
            isFullDuplex: this.isFullDuplex,
            isColor: this.isColor
          }

          console.debug('mail params=' + JSON.stringify(params))

          await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
            params,
            done: async ({ detail }) => {
              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })

              this.$store.dispatch('communication/saveCompositionMethod', {
                compositionMethod: 'html'
              })

              if (detail) {
                console.debug('update communication=' + JSON.stringify(detail))

                this.communicationID = detail.communicationID

                notifyMessage('This message has been saved for sending.')
                loadingComponent.close()
              }
            }
          })
        }
      } catch (error) {
        console.debug('error=' + error.message)
        loadingComponent.close()
      }

      loadingComponent.close()
    }
  },

  async handleImageAdded(file, Editor, cursorLocation) {
    console.debug('in handleImageAdded...' + cursorLocation)

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    try {
      console.debug('file=' + file)

      if (file !== undefined && file) {
        const payload = {
          communicationID:
            this.mailingCommunicationID > 0 ? this.mailingCommunicationID : this.communicationID,
          cursorPosition: cursorLocation,
          supportsMail: true,
          supportsEmail: false,
          description: this.communicationDescription
        }

        console.debug('payload addConversationAttachment=' + JSON.stringify(payload))

        await mailingCommunicationStore.dispatch('addCommunicationAttachment', {
          payload,
          done: async ({ detail }) => {
            if (detail) {
              console.debug('addCommunicationAttachment=' + JSON.stringify(detail))

              const payload = {
                communicationAttachmentID: detail.communicationAttachmentID,
                file: file
              }

              await mailingCommunicationStore
                .dispatch('uploadCommunicationAttachmentDocument', {
                  payload: payload
                })
                .then(async returnedfile => {
                  this.$store.dispatch('communication/saveIsEdit', {
                    isEdit: true
                  })

                  if (returnedfile && detail) {
                    console.debug('returnedfile=' + JSON.stringify(returnedfile))

                    Editor.insertEmbed(
                      cursorLocation,
                      'image',
                      `${KMS_BACKEND}/MailingComponents/CommunicationAttachment/GetFilePublic?token=${detail.securityToken}`
                    )
                  }
                })
            }
          }
        })
      }
    } catch (e) {
      setTimeout(() => loadingComponent.close(), 7000)
      notifyError(e)
    }

    setTimeout(() => loadingComponent.close(), 7000)
  },

  async handleImageRemoved(file) {
    console.debug('in handleImageRemoved...')
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    const flatContents = JSON.stringify(file)
    const flatContentsSplit = flatContents.split('communicationAttachmentID=')
    const communicationAttachmentID = parseInt(
      flatContentsSplit[1] !== undefined && flatContentsSplit[1] ? flatContentsSplit[1] : 0
    )

    console.debug('communicationAttachmentID=' + communicationAttachmentID)

    if (communicationAttachmentID > 0) {
      try {
        await mailingCommunicationStore.dispatch('deleteCommunicationAttachment', {
          communicationAttachmentID,
          done: () => {}
        })
      } catch (e) {
        loadingComponent.close()
        console.debug('There was an issue deleting this communication attachment.' + e)
      }
    }

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })

    loadingComponent.close()
  },

  async getComposition() {
    this.communicationID = this.mailingCommunicationID
  },

  async processUploadAdd() {
    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    if (this.communicationID <= 0) {
      await this.getComposition()
    }

    this.processUpload()
  },

  async processComposeAdd() {
    console.debug('processComposeAdd()...' + this.communicationID)

    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    if (this.communicationID <= 0) {
      await this.getComposition()
    }

    this.composedText = this.mailMessage || ''

    this.$store.dispatch('communication/selectedUploadFile', {
      uploadFile: null
    })
    this.$store.dispatch('communication/savePdfFileName', {
      pdfFileName: ''
    })

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })
  },

  processFinalPreview(content, subject, isDuplexParam, isColorParam) {
    console.debug('in processFinalPreview...' + content)
    this.$store.dispatch('communication/composedMailMessage', {
      mailMessage: content
    })

    this.$store.dispatch('communication/saveIsFullDuplex', {
      isFullDuplex: isDuplexParam
    })

    this.$store.dispatch('communication/saveIsColor', {
      isColor: isColorParam
    })

    this.composedText = content
  },

  zoom(direction) {
    const amt = Math.sqrt(2)
    if (direction > 0) {
      this.scale *= amt
    } else {
      this.scale /= amt
    }

    // constrain to min/max
    this.scale = Math.max(0.5, Math.min(4, this.scale))
  },

  loadUploadOrEnterList() {
    console.debug('loadUploadOrEnterList...')
    try {
      this.uploadOrEnterList = [
        { value: '', label: '<- Select Upload or Enter ->' },
        { value: 'Upload', label: 'Upload' },
        { value: 'Enter', label: 'Enter Content' }
      ]

      this.formData.uploadOrEnter = ''

      console.debug('this.mailMessage===' + this.mailMessage)
      console.debug('this.pdfFileName===' + this.pdfFileName)
      console.debug('this.compositionMethod===' + this.compositionMethod)

      if (
        this.mailMessage &&
        this.compositionMethod !== undefined &&
        (this.compositionMethod === 'html' || this.compositionMethod === '')
      ) {
        this.formData.uploadOrEnter = 'Enter'
      } else if (
        this.compositionMethod !== undefined &&
        this.compositionMethod === 'pdf-document'
      ) {
        console.debug('loadUploadOrEnterList upload...')
        this.formData.uploadOrEnter = 'Upload'
      }

      console.debug('loadUploadOrEnterList=' + JSON.stringify(this.uploadOrEnterList))
    } catch (e) {
      console.debug(e)
    }
  },

  async reload() {
    this.loading = true

    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('compose mail communicationID=' + this.communicationID)

    this.loadUploadOrEnterList()

    if (!this.communicationID) {
      this.communicationID = this.mailingCommunicationID
    }

    this.composedText = this.mailMessage

    if (
      this.communication !== undefined &&
      this.communication &&
      this.communication.communicationID !== undefined &&
      this.communication.communicationID
    ) {
      if (
        this.communication.compositionMethod &&
        this.communication.compositionMethod === 'pdf-document'
      ) {
        this.getDocument(true)
      }
    }

    if (this.composedText && this.composedText.length > 0) {
      this.processComposeAdd()
    }

    try {
      await mailingCommunicationStore
        .dispatch('getCommunicationById', {
          communicationID:
            this.mailingCommunicationID > 0 ? this.mailingCommunicationID : this.communicationID
        })
        .then(async ({ result }) => {
          if (this.isDebug == true) console.debug('communication=' + JSON.stringify(result))

          if (result) {
            this.communication = result

            console.debug('this.mailMessage===' + this.mailMessage)
            console.debug('this.pdfFileName===' + this.pdfFileName)
            console.debug('this.compositionMethod===' + this.compositionMethod)

            if (
              (this.mailMessage &&
                this.communication.compositionMethod === 'html' &&
                this.compositionMethod !== undefined &&
                (this.compositionMethod === 'html' || this.compositionMethod === '') &&
                this.communication.compositionMethod !== 'pdf-document') ||
              this.communication.compositionMethod === 'html'
            ) {
              this.formData.uploadOrEnter = 'Enter'

              this.$store.dispatch('communication/composedMailMessage', {
                mailMessage: this.communication.htmlContent
              })

              console.debug('loaded communication mailMessage=' + this.mailMessage)
            } else if (
              (this.compositionMethod !== undefined && this.compositionMethod === 'pdf-document') ||
              this.communication.compositionMethod === 'pdf-document'
            ) {
              this.formData.uploadOrEnter = 'Upload'
              await this.processPreview()
            }
          }
        })
    } catch (e) {
      console.debug('error while loading reload communication update method:' + e)
    }

    this.loading = false
  },

  async onFormSubmit() {},

  async submitFile() {
    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    this.$store.dispatch('communication/saveCompositionMethod', {
      compositionMethod: 'pdf-document'
    })

    console.debug('in submitFile...')
    this.$store
      .dispatch('communication/selectedUploadFile', {
        uploadFile: this.file
      })
      .then(() => {
        this.$store
          .dispatch('communication/savePdfFileName', {
            pdfFileName: this.file.name
          })
          .then(() => {
            this.$store
              .dispatch('communication/saveCompositionMethod', {
                compositionMethod: 'pdf-document'
              })
              .then(() => {
                this.$store
                  .dispatch('communication/saveIsFullDuplex', {
                    isFullDuplex: false
                  })
                  .then(() => {
                    this.$store
                      .dispatch('communication/saveIsColor', {
                        isColor: false
                      })
                      .then(() => {
                        this.$store.dispatch('communication/composedMailMessage', {
                          mailMessage: ''
                        })
                      })
                  })
              })
          })
      })

    console.debug('this.file=' + this.file)

    if (this.file !== undefined && this.file) {
      console.debug('file is not null and communicationID=')
      if (this.communicationID > 0 || this.mailingCommunicationID) {
        const payload = {
          file: this.file,
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID
        }

        console.debug(
          'communicationID=' + this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID
        )
        await mailingCommunicationStore
          .dispatch('uploadCommunicationDocument', {
            payload
          })
          .then(async ({ returnedfile }) => {
            if (returnedfile) {
              this.documentID = returnedfile.documentID

              const params = {
                communicationID: this.mailingCommunicationID
                  ? this.mailingCommunicationID
                  : this.communicationID,
                supportMailDelivery: true,
                supportSMSDelivery: false,
                supportEmailDelivery: false,
                isLegalCommunication: this.isLegalCommunication,
                htmlContent: this.content,
                documentID: this.documentID,
                compositionMethod: 'pdf-document',
                description: this.communicationDescription,
                mailingTypeID: this.mailingTypeID,
                selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
                selectedDeliveryOwners: this.selectedDeliveryOwners,
                deliveryDate: this.deliveryDate,
                isFullDuplex: this.isFullDuplex,
                isColor: this.isColor
              }

              await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
                params,
                done: async ({ detail }) => {
                  if (detail) {
                    console.debug('update communication=' + JSON.stringify(detail))

                    this.communicationID = detail.communicationID

                    this.$store
                      .dispatch('communication/saveCompositionMethod', {
                        compositionMethod: 'pdf-document'
                      })
                      .then(() => {
                        this.$store
                          .dispatch('communication/composedMailMessage', {
                            mailMessage: ''
                          })
                          .then(() => {
                            this.$store.dispatch('communication/saveIsEdit', {
                              isEdit: true
                            })
                          })
                      })

                    notifyMessage('The document has been successfully saved.')

                    this.$router.push({
                      path: `/communicationtabs/${
                        this.mailingCommunicationID
                          ? this.mailingCommunicationID
                          : this.communicationID
                      }/composeMail#tab`,
                      query: { readonly: true }
                    })

                    await this.processPreview()
                  }
                }
              })
            }
          })
      }
      loadingComponent.close()
    }
  },

  async processPreview() {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    await this.getDocument(false)
    loadingComponent.close()
  },

  async getDocument(isEdit) {
    if (!this.mailingCommunicationID && !this.communicationID) {
      notifyError('Please Save your General Information first.')
      return
    }

    console.debug('getDocument___________________________________________' + isEdit)

    try {
      const params = {
        communicationID: this.mailingCommunicationID
          ? this.mailingCommunicationID
          : this.communicationID,
        asBase64: true
      }

      await mailingCommunicationStore
        .dispatch('getCommunicationDocumentGetFile', {
          params: params
        })
        .then(({ returned }) => {
          if (returned) {
            this.documentFile = returned
          }

          if (this.isDebug == true)
            console.debug(' - params' + JSON.stringify(params) + ' - this.documentFile=' + returned)
          if (this.documentFile && this.documentFile != undefined) {
            if (this.isDebug == true)
              console.debug('image or pdf............this.searchTerm:' + this.documentFile)

            this.base64pdf = this.documentFile
            this.imageContent = null

            if (isEdit && isEdit === true) {
              console.debug('converting base64 to file object..............')
              if (this.documentFile) {
                console.debug('converting base64 to file object..............')
                const mimeType = (this.documentFile.match(/^data:([^;]+);/) || '')[1]
                const returnedFile = this.dataURLtoFile(
                  this.documentFile,
                  `request-file.${mimeType.replace('image/', '')}`
                )

                if (returnedFile) {
                  console.debug('converting base64 to file object..............')
                  this.file = returnedFile
                  this.$store
                    .dispatch('communication/selectedUploadFile', {
                      uploadFile: this.file
                    })
                    .then(() => {
                      this.$store
                        .dispatch('communication/savePdfFileName', {
                          pdfFileName: this.file.name
                        })
                        .then(() => {
                          console.debug('converting base64 to file object..............')
                        })
                    })
                }
              }
            }
          }
        })
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
    }
  },

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }
}
